import i18n from '../../i18n';

const isString = (type) => typeof type === 'string';

const isMasters = (type) => type === "MASTER";

const isBL = (type) => type === "BL";

const getTitleOfMaster = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.listar');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.listar');
    }

    return "Master";

}

const getNovoMasterOrBl = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.novo');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.novo');
    }

    return "Master";
}

const getExisteMasterOrBl = (type, id) => {
   
    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.existe', { id });
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.existe', { id });
    }

    return "Master";
}

const getNumero = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.numero');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.numero');
    }

    return "Master";

}

const getConsignatario = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.consignatario');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.consignatario');
    }

    return "Master";

}

const getExportador = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.exportador');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.exportador');
    }

    return "Master";

}

const getCiaAerea = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.cia_aerea');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.cia_aerea');
    }

    return "Master";

}

const getOrigem = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.origem');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.origem');
    }

    return "Master";

}

const getDestino = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.destino');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.destino');
    }

    return "Master";

}

const getTipoFrete = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.tipo_frete');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.tipo_frete');
    }

    return "Master";

}

const getTipoEmbarque = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.tipo_embarque');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.tipo_embarque');
    }

    return "Master";

}

const getPesoBruto = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isMasters(type)) {
        return i18n.t('com.muralis.qcx.master.peso_bruto');
    }

    if(isBL(type)) {
        return i18n.t('com.muralis.qcx.bls.peso_bruto');
    }

    return "Master";

}

export {
    isString,
    isMasters,
    isBL,
    getTitleOfMaster,
    getNovoMasterOrBl,
    getExisteMasterOrBl,
    getNumero,
    getConsignatario,
    getExportador,
    getCiaAerea,
    getOrigem,
    getDestino,
    getTipoFrete,
    getTipoEmbarque,
    getPesoBruto,
}